// src/pages/SriLanka.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

// === HERO & INTRO IMAGES ===
import sriLankaHeroBg from '../assets/Aamy/33.jpg';
import introImage from '../assets/Aamy/37.jpg';

// === PLACE IMAGES (unchanged — keep your current imports) ===
import place1 from '../assets/Sri Lanka/800px-Sigiriya_(141688197).jpeg';
import place17 from '../assets/Sri Lanka/Sigiriya-Uncovered-Delving-into-the-History-Art-and-Legends-800x609-1.jpg';
import place18 from '../assets/Sri Lanka/01.jpg';
import place19 from '../assets/Sri Lanka/Sigriya_rock_from_directly_above_1600x.webp';

import place2 from '../assets/Sri Lanka/Kandy-toothrelictemple-dawn.jpg';
import place20 from '../assets/Sri Lanka/temple-sacred-tooth-relic-kandy-sri-lanka.jpg';
import place21 from '../assets/Sri Lanka/Temple-Sacred-Tooth-Relic-kandy-sri-lanka (1).jpg';
import place22 from '../assets/Sri Lanka/Kandy-and-The-Temple.jpg';

import place3 from '../assets/Sri Lanka/Nine Arch Bridge Sri Lanka.jpg';
import place23 from '../assets/Sri Lanka/little-adams-peak-ella-1440x960.jpg';
import place24 from '../assets/Sri Lanka/POST_PORTRAIT_0002_IMG_9077.webp';
import place25 from '../assets/Sri Lanka/52773560Ravana_Falls.jpg';

import place4 from '../assets/Sri Lanka/Yala-National-Park-1.jpg';
import place26 from '../assets/Sri Lanka/hq720.jpg';
import place27 from '../assets/Sri Lanka/image_872e72884c.jpg';
import place28 from '../assets/Sri Lanka/yala-safari-srilanka-economy-tours.jpg.webp';

import place5 from '../assets/Sri Lanka/Galle-Fort.webp';
import place29 from '../assets/Sri Lanka/galle_147f8ef7-7d19-4c30-9069-eb59128e1c2c.webp';
import place30 from '../assets/Sri Lanka/Galle-Fort-Walking-Tour-555x655-1.jpg';
import place31 from '../assets/Sri Lanka/shutterstock-409990654_main_1490260387805.jpeg';

import place6 from '../assets/Sri Lanka/nuwara-eliya-in-sri-lanka.jpg';
import place32 from '../assets/Sri Lanka/historical-background-in-nuwara-eliya.jpg';
import place33 from '../assets/Sri Lanka/grand-hotel-nuwara-eliya.jpg';
import place34 from '../assets/Sri Lanka/nuwara-eliya-gregory.jpg';

import place7 from '../assets/Sri Lanka/Climb-Adams-Peak-Sri-Pada.webp';
import place35 from '../assets/Sri Lanka/Adams-Peak-Sri-Lanka.webp';
import place36 from '../assets/Sri Lanka/mini-adams-peak-1-7.jpg';
import place37 from '../assets/Sri Lanka/adams-peak-season.jpg';

import place8 from '../assets/Sri Lanka/800x750-94.jpg';
import place38 from '../assets/Sri Lanka/Michael-at-Worlds-End-View-Horton-Plains-National-Park.jpg';
import place39 from '../assets/Sri Lanka/horton-plains-national.jpg';
import place40 from '../assets/Sri Lanka/Horton-Plains-Nature-Reserve-800x600-1.webp';

import place9 from '../assets/Sri Lanka/Bentota-Sri-Lanka-Everything-You-Need-To-Know.jpg';
import place41 from '../assets/Sri Lanka/Ventura-Beach-Sri-Lanka-Bentota-Beach-2023-2024.jpg';
import place42 from '../assets/Sri Lanka/bentota.jpg';
import place43 from '../assets/Sri Lanka/01 (1).jpg';

import place10 from '../assets/Sri Lanka/images.jpeg';
import place44 from '../assets/Sri Lanka/1332748-jaffna-library.jpg';
import place45 from '../assets/Sri Lanka/Jaffna-Fort-Jaffna-Sri-Lanka.jpg.webp';
import place46 from '../assets/Sri Lanka/Nainatheevu-in-Jaffna-768x1024.jpeg';

import place11 from '../assets/Sri Lanka/800x750-1.jpg';
import place47 from '../assets/Sri Lanka/shutterstock-480723793_main_1481633955837.jpeg';
import place48 from '../assets/Sri Lanka/Avukana-Buddha-Statue-Anuradhapua-Ancinet-City.webp';
import place49 from '../assets/Sri Lanka/Anuradhapura-788x537.webp';

import place12 from '../assets/Sri Lanka/Polonnaruwa-Lankathilaka-Feature-Image.jpg';
import place50 from '../assets/Sri Lanka/UNESCO-World-Heritage-Site-Brahmanic-Monuments-Polonnaruwa-Sri-Lanka-1.jpg';
import place51 from '../assets/Sri Lanka/ThePolonnaruwaVatadage-857341721661428.jpg';
import place52 from '../assets/Sri Lanka/polonnaruwa-640x360.jpg';

import place13 from '../assets/Sri Lanka/Unawatuna-Beach-1.jpg';
import place53 from '../assets/Sri Lanka/Unawatuna-Beach-Sri-Lanka.webp';
import place54 from '../assets/Sri Lanka/20190926_080608-1024x768.webp';
import place55 from '../assets/Sri Lanka/jungle-beach-unawatuna-00-1024x768.webp';

import place14 from '../assets/Sri Lanka/37.jpg';
import place56 from '../assets/Sri Lanka/Colombo-city.jpg';
import place57 from '../assets/Sri Lanka/colombo-main-header.jpg';
import place58 from '../assets/Sri Lanka/ee.jpg';

import place15 from '../assets/Sri Lanka/udawalawe-national-park.jpg';
import place59 from '../assets/Sri Lanka/Udawalawe-National-Park-2.jpeg';
import place60 from '../assets/Sri Lanka/12f5bb1d6b11d9f5a5a9b1f64c59bd41-uda-walawe-national-park.jpg';
import place61 from '../assets/Sri Lanka/156-1024x683.jpg';

import place16 from '../assets/Sri Lanka/01 (2).jpg';
import place62 from '../assets/Sri Lanka/800x750-9.jpg';
import place63 from '../assets/Sri Lanka/dambulla-cave-temple-architecture-1024x585.jpg';
import place64 from '../assets/Sri Lanka/555x465px-Dambulla_cave_temple_37.webp';

// === FAMOUS THINGS IMAGES ===
import ceylonTea from '../assets/Sri Lanka/30917a4b2dee144385c49297465d68a3_XL-768x340.jpg';
import spices from '../assets/Sri Lanka/Spices_1200px_23_11_16-1000x600.jpg';
import gems from '../assets/Sri Lanka/Untitled-61.jpg';
import ayurveda from '../assets/Sri Lanka/Ayurveda-Background-gallery-pop-up-(1)-min.jpg';
import handicrafts from '../assets/Sri Lanka/Local-handicraft-workshops-and-shopping-in-Galle.jpg';
import elephants from '../assets/Sri Lanka/Asian-elephant-Elephas-Maximus.webp';
import food from '../assets/Sri Lanka/1689750105634.jpeg';
import festivals from '../assets/Sri Lanka/Three-tuskers-clad-in-illuminated-red-costumes-standing-in-front-of-the-illuminated-white-building-complex-1.jpg';
import coconut from '../assets/Sri Lanka/processed-coconut-products.webp';
import sarees from '../assets/Sri Lanka/E015.webp';
import dances from '../assets/Sri Lanka/DSC_2290-1038x576.jpg';
import stiltFishing from '../assets/Sri Lanka/S4.jpg';
import moonstones from '../assets/Sri Lanka/moonstone-3.jpg';
import cricket from '../assets/Sri Lanka/image_f8c21aee4f.jpg';
import herbs from '../assets/Sri Lanka/Ayurveda-making.jpg';
import masks from '../assets/Sri Lanka/Sri-lankan-Masks.jpg';

// === MOTION VARIANTS ===
const sectionVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } },
};

const SriLanka = () => {
    const { t } = useTranslation('srilanka');
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (place) => setSelectedPlace(place);
    const closeModal = () => setSelectedPlace(null);
    const openImagePreview = (image) => setSelectedImage(image);
    const closeImagePreview = () => setSelectedImage(null);

    // === DATA ARRAYS — fully translated ===
    const places = [
        { name: t('sigiriya'), desc: t('sigiriyaDesc'), images: [place1, place17, place18, place19] },
        { name: t('templeOfTooth'), desc: t('templeOfToothDesc'), images: [place2, place20, place21, place22] },
        { name: t('ella'), desc: t('ellaDesc'), images: [place3, place23, place24, place25] },
        { name: t('yala'), desc: t('yalaDesc'), images: [place4, place26, place27, place28] },
        { name: t('galleFort'), desc: t('galleFortDesc'), images: [place5, place29, place30, place31] },
        { name: t('nuwaraEliya'), desc: t('nuwaraEliyaDesc'), images: [place6, place32, place33, place34] },
        { name: t('adamsPeak'), desc: t('adamsPeakDesc'), images: [place7, place35, place36, place37] },
        { name: t('hortonPlains'), desc: t('hortonPlainsDesc'), images: [place8, place38, place39, place40] },
        { name: t('bentota'), desc: t('bentotaDesc'), images: [place9, place41, place42, place43] },
        { name: t('jaffna'), desc: t('jaffnaDesc'), images: [place10, place44, place45, place46] },
        { name: t('anuradhapura'), desc: t('anuradhapuraDesc'), images: [place11, place47, place48, place49] },
        { name: t('polonnaruwa'), desc: t('polonnaruwaDesc'), images: [place12, place50, place51, place52] },
        { name: t('unawatuna'), desc: t('unawatunaDesc'), images: [place13, place53, place54, place55] },
        { name: t('colombo'), desc: t('colomboDesc'), images: [place14, place56, place57, place58] },
        { name: t('udawalawe'), desc: t('udawalaweDesc'), images: [place15, place59, place60, place61] },
        { name: t('dambulla'), desc: t('dambullaDesc'), images: [place16, place62, place63, place64] },
    ];

    const famousThings = [
        { title: t('ceylonTea'), desc: t('ceylonTeaDesc'), image: ceylonTea },
        { title: t('spices'), desc: t('spicesDesc'), image: spices },
        { title: t('gems'), desc: t('gemsDesc'), image: gems },
        { title: t('ayurveda'), desc: t('ayurvedaDesc'), image: ayurveda },
        { title: t('handicrafts'), desc: t('handicraftsDesc'), image: handicrafts },
        { title: t('elephants'), desc: t('elephantsDesc'), image: elephants },
        { title: t('food'), desc: t('foodDesc'), image: food },
        { title: t('festivals'), desc: t('festivalsDesc'), image: festivals },
        { title: t('coconut'), desc: t('coconutDesc'), image: coconut },
        { title: t('sarees'), desc: t('sareesDesc'), image: sarees },
        { title: t('dances'), desc: t('dancesDesc'), image: dances },
        { title: t('stiltFishing'), desc: t('stiltFishingDesc'), image: stiltFishing },
        { title: t('moonstones'), desc: t('moonstonesDesc'), image: moonstones },
        { title: t('cricket'), desc: t('cricketDesc'), image: cricket },
        { title: t('herbs'), desc: t('herbsDesc'), image: herbs },
        { title: t('masks'), desc: t('masksDesc'), image: masks },
    ];

    const intro = [t('intro1'), t('intro2'), t('intro3'), t('intro4'), t('intro5')];

    return (
        <div className="bg-[#0a0a0a] min-h-screen">
            {/* HERO SECTION */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="relative flex h-[60vh] w-full items-center justify-center font-lato md:h-[50vh] lg:h-[80vh] overflow-hidden"
            >
                <img src={sriLankaHeroBg} alt={t('heroTitle')} className="absolute inset-0 h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/85" />

                <div className="container relative z-10 flex flex-col items-center justify-center pt-[80px] px-4">
                    <h1 className="text-center text-[50px] font-bold leading-[70px] text-[#96BA33] font-konkhmer md:text-[60px] lg:text-[80px]">

                        {t('heroTitle')}

                    </h1>
                    <p className="mt-6 max-w-[90%] text-center font-inknut text-lg font-medium text-white/90 sm:mt-10 sm:max-w-3xl sm:text-2xl">
                        {t('heroSubtitle')}
                    </p>

                    {/* Gradient Corner SVGs */}
                    <div className="absolute left-6 top-12 md:left-10 md:top-16">
                        <svg width="340" height="300" viewBox="0 0 340 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M340 1H1V299.5" stroke="url(#gradLeft)" strokeWidth="1.8" />
                            <defs>
                                <linearGradient id="gradLeft" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#166880" />
                                    <stop offset="100%" stopColor="#D5A44F" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div className="absolute -bottom-12 right-6 md:-bottom-16 md:right-10">
                        <svg width="340" height="300" viewBox="0 0 340 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 299.5H339V0" stroke="url(#gradRight)" strokeWidth="1.8" />
                            <defs>
                                <linearGradient id="gradRight" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#D5A44F" />
                                    <stop offset="100%" stopColor="#166880" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
            </motion.div>

            {/* INTRO SECTION */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-16 lg:py-24">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
                        <div className="w-full lg:w-1/2">
                            <img src={introImage} alt="Sri Lanka" className="w-full h-auto object-cover rounded-2xl shadow-2xl border border-white/10" loading="lazy" />
                        </div>
                        <div className="w-full lg:w-1/2 space-y-6 text-white/90">
                            {intro.map((paragraph, i) => (
                                <p key={i} className="text-sm md:text-base lg:text-lg leading-relaxed font-inknut">
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* ATTRACTIVE PLACES SECTION */}
            <section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-10 lg:py-12">
                <div className="container mx-auto px-4">
                    <h2
                        className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-16 text-[#96BA33]"

                    >
                        {t('sectionPlaces')}
                    </h2>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 place-items-center">
                        {places.map((place, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05, y: -8 }}
                                whileTap={{ scale: 0.98 }}
                                className="group relative w-full max-w-[320px] cursor-pointer overflow-hidden rounded-2xl shadow-xl transition-all duration-500 hover:shadow-2xl flex flex-col bg-black/50 backdrop-blur-sm border border-white/10"
                                onClick={() => openModal(place)}
                            >
                                <div className="relative flex-1">
                                    <img src={place.images[0]} alt={place.name} className="h-64 w-full object-cover transition-transform duration-700 group-hover:scale-115" loading="lazy" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                </div>
                                <div className="p-5 text-center">
                                    <h3 className="text-white font-konkhmer text-lg font-bold mb-3 drop-shadow-md">{place.name}</h3>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openModal(place);
                                        }}
                                        className="rounded-full px-5 py-2 font-semibold text-white text-xs md:text-sm transition-all duration-300 shadow-lg hover:scale-105"
                                        style={{
                                            background: 'linear-gradient(to right, #166880, #D5A44F)',
                                            boxShadow: '0 4px 14px rgba(22, 104, 128, 0.4)',
                                        }}
                                        onMouseEnter={(e) =>
                                            e.target.style.background = 'linear-gradient(to right, #0f4d5e, #b88a3a)'
                                        }
                                        onMouseLeave={(e) =>
                                            e.target.style.background = 'linear-gradient(to right, #166880, #D5A44F)'
                                        }
                                    >
                                        {t('viewMore')}
                                    </button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAMOUS THINGS SECTION */}
            <section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-10 lg:py-12">
                <div className="container mx-auto px-4">
                    <h2
                        className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-16 text-[#96BA33]"

                    >
                        {t('sectionFamous')}
                    </h2>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 place-items-center">
                        {famousThings.map((item, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05, y: -8 }}
                                whileTap={{ scale: 0.98 }}
                                className="group relative w-full max-w-[320px] overflow-hidden rounded-2xl shadow-xl transition-all duration-500 hover:shadow-2xl flex flex-col bg-black/50 backdrop-blur-sm border border-white/10"
                            >
                                <div className="relative flex-1">
                                    <img src={item.image} alt={item.title} className="h-64 w-full object-cover transition-transform duration-700 group-hover:scale-115" loading="lazy" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center p-5">
                                        <div className="text-center">
                                            <h3 className="text-white font-bold text-lg mb-2 drop-shadow-md">{item.title}</h3>
                                            <p className="text-white text-sm line-clamp-3">{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-5 text-center">
                                    <h3 className="text-white font-konkhmer text-lg font-bold drop-shadow-md">{item.title}</h3>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* MODAL: PLACE DETAILS */}
            {selectedPlace && (
                <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-y-auto">
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        className="bg-[#111]/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 md:p-10 max-w-6xl w-full max-h-[90vh] overflow-y-auto border border-white/10"
                    >
                        <button onClick={closeModal} className="absolute top-6 right-6 bg-white/20 text-white rounded-full p-3 hover:bg-white/30 transition-all duration-300 shadow-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <h2
                            className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8"
                            style={{
                                background: "linear-gradient(to right, #166880, #D5A44F)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                                textShadow: '0 0 15px rgba(213, 164, 79, 0.4)',
                            }}
                        >
                            {selectedPlace.name}
                        </h2>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
                            {selectedPlace.images.map((img, i) => (
                                <motion.img
                                    key={i}
                                    whileHover={{ scale: 1.05 }}
                                    src={img}
                                    alt={`${selectedPlace.name} ${i + 1}`}
                                    className="w-full h-48 md:h-64 object-cover rounded-xl cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-300 border border-white/10"
                                    onClick={() => openImagePreview(img)}
                                    loading="lazy"
                                />
                            ))}
                        </div>
                        <p className="text-white/90 text-sm md:text-base lg:text-lg leading-relaxed font-inknut">
                            {selectedPlace.desc}
                        </p>
                    </motion.div>
                </div>
            )}

            {/* FULL IMAGE PREVIEW MODAL */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black/98 flex items-center justify-center z-50 p-6">
                    <div className="relative max-w-6xl w-full">
                        <img src={selectedImage} alt="Full Preview" className="max-w-full max-h-full object-contain rounded-2xl shadow-2xl" />
                        <button onClick={closeImagePreview} className="absolute top-6 right-6 bg-white/20 text-white rounded-full p-3 hover:bg-white/30 transition-all duration-300 shadow-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SriLanka;